var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondRankIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 112,
    viewBox: "0 0 113 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17561_53082)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 0,
    width: 22,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.2751 40.848H52.4392L45.8164 0H66.9118L60.2751 40.848Z",
    fill: "url(#paint0_linear_17561_53082)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2751 40.848H52.4392L45.8164 0H66.9118L60.2751 40.848Z",
    fill: "url(#paint1_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 4,
    width: 36,
    height: 43
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6536 41.4355L44.3096 46.0503L15.002 16.9211L32.0818 4.4751L50.6536 41.4355Z",
    fill: "url(#paint2_linear_17561_53082)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6536 41.4355L44.3096 46.0503L15.002 16.9211L32.0818 4.4751L50.6536 41.4355Z",
    fill: "url(#paint3_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 28,
    width: 44,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2086 47.5886L40.7826 55.0562L0 48.7633L6.52521 28.626L43.2086 47.5886Z",
    fill: "url(#paint4_linear_17561_53082)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2086 47.5886L40.7826 55.0562L0 48.7633L6.52521 28.626L43.2086 47.5886Z",
    fill: "url(#paint5_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 56,
    width: 44,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7826 56.9438L43.2086 64.4114L6.52521 83.3741L0 63.2368L40.7826 56.9438Z",
    fill: "url(#paint6_linear_17561_53082)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7826 56.9438L43.2086 64.4114L6.52521 83.3741L0 63.2368L40.7826 56.9438Z",
    fill: "url(#paint7_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 65,
    width: 36,
    height: 43
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 65.9497L50.6536 70.5645L32.0818 107.525L15.002 95.0789L44.3096 65.9497Z",
    fill: "url(#paint8_linear_17561_53082)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3096 65.9497L50.6536 70.5645L32.0818 107.525L15.002 95.0789L44.3096 65.9497Z",
    fill: "url(#paint9_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 71,
    width: 22,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4392 71.1519H60.2751L66.9118 112H45.8164L52.4392 71.1519Z",
    fill: "url(#paint10_linear_17561_53082)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.4392 71.1519H60.2751L66.9118 112H45.8164L52.4392 71.1519Z",
    fill: "url(#paint11_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 65,
    width: 36,
    height: 43
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0732 70.5645L68.4033 65.9497L97.7109 95.0789L80.645 107.525L62.0732 70.5645Z",
    fill: "url(#paint12_linear_17561_53082)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0732 70.5645L68.4033 65.9497L97.7109 95.0789L80.645 107.525L62.0732 70.5645Z",
    fill: "url(#paint13_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 56,
    width: 44,
    height: 28
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 64.4114L71.9307 56.9438L112.727 63.2368L106.202 83.3741L69.5186 64.4114Z",
    fill: "url(#paint14_linear_17561_53082)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.5186 64.4114L71.9307 56.9438L112.727 63.2368L106.202 83.3741L69.5186 64.4114Z",
    fill: "url(#paint15_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 28,
    width: 44,
    height: 28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 55.0562L69.5186 47.5886L106.202 28.626L112.727 48.7633L71.9307 55.0562Z",
    fill: "url(#paint16_linear_17561_53082)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9307 55.0562L69.5186 47.5886L106.202 28.626L112.727 48.7633L71.9307 55.0562Z",
    fill: "url(#paint17_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 62,
    y: 4,
    width: 36,
    height: 43
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 46.0503L62.0732 41.4355L80.645 4.4751L97.7109 16.9211L68.4033 46.0503Z",
    fill: "url(#paint18_linear_17561_53082)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_17561_53082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.4033 46.0503L62.0732 41.4355L80.645 4.4751L97.7109 16.9211L68.4033 46.0503Z",
    fill: "url(#paint19_linear_17561_53082)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_17561_53082",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 26,
    width: 87,
    height: 66
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5512 53.736C12.3986 50.4428 12.1374 45.3362 14.9373 41.7384L24.4265 29.5453C26.1674 27.3083 28.8434 26 31.678 26H80.5274C83.3843 26 86.0786 27.3288 87.8176 29.5953L97.1551 41.7653C99.91 45.356 99.6402 50.418 96.5192 53.6954L62.7592 89.1479C59.1445 92.9438 53.0919 92.9518 49.4672 89.1654L15.5512 53.736Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_17561_53082)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0674 48.0024L27.1906 26H85.0641L101.945 48.0024L56.1273 96.1175L10.0674 48.0024Z",
    fill: "url(#paint20_linear_17561_53082)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0508 48.0015L31.2553 55.0035L56.1107 96.1166L10.0508 48.0015Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M101.811 48.0015L80.254 55.0035L56.1094 96.1166L101.811 48.0015Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7567 30.8119L26.9844 25.9907L31.2543 55.0049H55.6358H55.8776H80.2543L84.5242 25.9907L55.7567 30.8119Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9844 25.9907L56.1097 35.6621L85.0465 26.0004L26.9844 25.9907Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7514 30.8086L31.249 55.0015H80.249L55.7514 30.8086Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1045 35.6621L31.249 55.0049H80.249L56.1045 35.6621Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2553 55.0049L10.0508 48.0028L26.9854 25.9907H31.2553V55.0049Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2549 55.0049L101.938 48.0028L85.0035 25.9907H80.7336L80.2549 55.0049Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.249 55.0054L55.9836 96.0557L80.249 55.0054H31.249Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3,
    filter: "url(#filter0_i_17561_53082)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.249 55.0054L55.9836 96.0557L80.249 55.0054H31.249Z",
    fill: "black"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78C93 75.2319 90.7536 73 88 73C90.7681 73 93 70.7536 93 68C93 70.7681 95.2464 73 98 73C95.2464 73 93 75.2319 93 78Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 59C25.5 57.0695 23.9305 55.5 22 55.5C23.9305 55.5 25.5 53.9305 25.5 52C25.5 53.9305 27.0695 55.5 29 55.5C27.0695 55.5 25.5 57.0695 25.5 59Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 32C80.8807 32 82 30.8807 82 29.5C82 28.1193 80.8807 27 79.5 27C78.1193 27 77 28.1193 77 29.5C77 30.8807 78.1193 32 79.5 32Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M87 19.5C87 20.3239 86.3239 21 85.5 21C84.6761 21 84 20.3239 84 19.5C84 18.6761 84.6761 18 85.5 18C86.3239 18 87 18.6761 87 19.5Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25 71.5C25 72.3239 24.3239 73 23.5 73C22.6761 73 22 72.3239 22 71.5C22 70.6761 22.6761 70 23.5 70C24.3239 70 25 70.6761 25 71.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_17561_53082",
    x: 31.249,
    y: 51.0054,
    width: 49,
    height: 45.0503,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_17561_53082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17561_53082",
    x1: 56.3615,
    y1: 40.8506,
    x2: 56.3615,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17561_53082",
    x1: 56.3615,
    y1: 40.8506,
    x2: 56.3615,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17561_53082",
    x1: 47.4831,
    y1: 43.7436,
    x2: 23.4489,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17561_53082",
    x1: 47.4831,
    y1: 43.7436,
    x2: 23.4489,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17561_53082",
    x1: 41.9962,
    y1: 51.3177,
    x2: 3.2376,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17561_53082",
    x1: 41.9962,
    y1: 51.3177,
    x2: 3.2376,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17561_53082",
    x1: 41.9962,
    y1: 60.6825,
    x2: 3.23759,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_17561_53082",
    x1: 41.9962,
    y1: 60.6825,
    x2: 3.23759,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_17561_53082",
    x1: 47.4831,
    y1: 68.2566,
    x2: 23.4488,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_17561_53082",
    x1: 47.4831,
    y1: 68.2566,
    x2: 23.4488,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_17561_53082",
    x1: 56.3615,
    y1: 71.1494,
    x2: 56.3615,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_17561_53082",
    x1: 56.3615,
    y1: 71.1494,
    x2: 56.3615,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_17561_53082",
    x1: 65.2385,
    y1: 68.2566,
    x2: 89.2727,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_17561_53082",
    x1: 65.2385,
    y1: 68.2566,
    x2: 89.2727,
    y2: 101.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_17561_53082",
    x1: 70.7257,
    y1: 60.6825,
    x2: 109.484,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_17561_53082",
    x1: 70.7257,
    y1: 60.6825,
    x2: 109.484,
    y2: 73.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_17561_53082",
    x1: 70.7257,
    y1: 51.3177,
    x2: 109.484,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_17561_53082",
    x1: 70.7257,
    y1: 51.3177,
    x2: 109.484,
    y2: 38.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_17561_53082",
    x1: 65.2385,
    y1: 43.7436,
    x2: 89.2727,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2183,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.412,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5963,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7748,
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9477,
    stopColor: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_17561_53082",
    x1: 65.2385,
    y1: 43.7436,
    x2: 89.2727,
    y2: 10.7629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52ACA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_17561_53082",
    x1: 56.0064,
    y1: 26,
    x2: 56.0064,
    y2: 96.1175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#003B95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17561_53082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112.727,
    height: 112,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondRankIcon);
export default __webpack_public_path__ + "static/media/DiamondRankIcon.d0fdaeff.svg";
export { ForwardRef as ReactComponent };